<template>
  <container
    subHeaderTitle="세이프빌링<br /><b>보상 신청</b>"
    subHeaderText="가입자의 정보 확인이 꼭 필요합니다.<br />본인의 정보를 정확히 입력하시기 바랍니다."
    subHeaderAlign="center"
  >
    <section class="form-area mb-180">
      <v-container class="py-0">
        <v-row justify="center">
          <v-col cols="12" md="4" sm="6">
            <v-form v-model="valid" ref="form" onsubmit="return false;">
              <p>휴대폰번호</p>
              <div class="d-flex">
                <v-select
                  :items="items" 
                  item-text="text" 
                  item-value="value" 
                  v-model="teleCoCd" 
                  solo
                />
                <v-text-field
                  v-model="cellTelNo"
                  :rules="rules.cellTelNoRules"
                  label="'-'를 제외하고 입력"
                  mask="###########"
                  solo
                />
              </div>
              <p>이름</p>
              <v-text-field v-model="name" :rules="rules.nameRules" label="이름" solo />
              <p>생년월일</p>
              <v-text-field v-model="birth" :rules="rules.birthRules" label="19990101" mask="########" solo />
              <p>성별</p>
              <v-btn-toggle color="primary" borderless mandatory v-model="genCd">
                <v-btn value="M">남</v-btn>
                <v-btn value="F">여</v-btn>
              </v-btn-toggle>
              <p class="mt-8 mb-2">이메일</p>
              <v-text-field v-model="email" :rules="rules.emailRules" label="help@finbridge.co.kr" solo />
              <div class="recaptcha-area top-sm">
                <vue-recaptcha ref="recaptcha" v-model="recaptchaVerify" @verify="onVerify" @expired="onExpired" :sitekey="$cfg.recaptchaSiteKey"></vue-recaptcha>
                <div class="v-messages theme--light error--text mt-2">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message" v-if="!recaptchaVerifyCheck">로봇이 아닙니다를 체크해주세요</div>
                  </div>
                </div>
              </div>
              <div>
                <v-btn class="submit" rounded block large depressed color="primary" v-on:click="submit"
                :data-ga-category="gaEvent.category.support.safebilling.compensation.name" :data-ga-label="gaEvent.category.support.safebilling.compensation.label1" :data-ga-action="gaEvent.actions.buttonClick"
                >보상신청</v-btn>
              </div>
              <div class="text-center mt-3">
                <v-btn class="back" text rounded @click.stop="goBack"
                :data-ga-category="gaEvent.category.support.safebilling.compensation.name" :data-ga-label="gaEvent.category.support.safebilling.compensation.label2" :data-ga-action="gaEvent.actions.buttonClick"
                >취소</v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <!-- 처리 프로그레스 -->
    <v-dialog v-model="progressDialog" persistent max-width="100">
      <v-card>
        <v-progress-linear color="primary" indeterminate></v-progress-linear>
      </v-card>
    </v-dialog>
  </container>
</template>

<style lang="scss" scoped>
@import "@/styles/cscenter";
</style>

<script>
import Container from "@/pages/container/index.vue";
import {GaTracking} from "@/mixins/index.js";

export default {
  mixins: [GaTracking],
  name: "SafebillingCompensation",
  components: {
    Container
  },
  data() {
    return {
      items: [
        { text: 'SKT', value: '1' }
      ],
      valid: false,
      recaptchaVerify: false,
      recaptchaVerifyCheck: true,
      type: "request",
      teleCoCd: "1", //통신사구분코드
      name: "", // 이름
      birth: "", // 생년월일
      genCd: "M", // 성별코드
      cellTelNo: "", // 전화번호
      email: "", // 이메일
      prdtNo: "A001",
      progressDialog: false,
      rules: {
        nameRules: [(v) => !!v || "이름을 입력해주세요."],
        birthRules: [
          (v) => !!v || "생년월일을 입력해주세요.",
          (v) => (v && v.length >= 8 && /((1|2)[0-9]{3})(0[1-9]{1}|1[0-2]{1})(0[1-9]|(1|2)[0-9]{1}|3[0-1]{1})$/.test(v)) || "생년월일이 정확하지 않습니다."
        ],
        cellTelNoRules: [(v) => !!v || "휴대폰번호를 입력해주세요.", (v) => (v && v.length >= 11 && /(01[0])([1-9]{1}[0-9]{2,3})([0-9]{4})$/.test(v)) || "휴대폰번호가 정확하지 않습니다."],
        emailRules: [(v) => !!v || "이메일을 입력해주세요.", (v) => (v && /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i.test(v)) || "이메일이 정확하지 않습니다."]
      }
    };
  },
  computed: {
    form() {
      return {
        name: this.name,
        birth: this.birth,
        cellTelNo: this.cellTelNo
      };
    }
  },
  methods: {
    submit(e) {
      this.gaTracking(e);
      this.progressDialog = true;

      this.recaptchaVerifyCheck = this.recaptchaVerify;
      this.$refs.form.validate();

      if (!this.valid) {
        this.progressDialog = false;
        return false;
      }
      if (!this.recaptchaVerify) {
        this.progressDialog = false;
        return false;
      }

      this.axios
        // .post("/rest/callSafebilling", {
        .post("/rest/sbCompensation", {
          actionType: this.type,
          cellTelNo: this.cellTelNo,
          birth: this.birth,
          genCd: this.genCd,
          name: this.name,
          email: this.email
        })
        .then((result) => {
          this.progressDialog = false;

          // if (result.data.isSucceed) {
          if (result.data.resultCd === "S0000") {
            this.$router.push({
              name: "SafebillingResult",
              params: { type: this.type, result: "SUCCESS" }
            });
          } else {
            this.$router.push({ name: "SafebillingResult", params: { type: this.type, result: "FAIL" } });
          }
        })
        .catch((result) => {
          this.progressDialog = false;

          this.$router.push({ name: "SafebillingResult", params: { type: this.type, result: "FAIL" } });
        });
    },
    onVerify(r) {
      this.recaptchaVerify = true;
      this.recaptchaVerifyCheck = this.recaptchaVerify;
    },
    onExpired() {
      this.$refs.recaptcha.reset();
    },
    exec() {
      this.$refs.recaptcha.execute();
    },
    reset() {
      this.$refs.recaptcha.reset();
    },
    goBack(e) {
      this.gaTracking(e);
      this.$router.push({ name: 'Support' });
    }
  }
};
</script>
